import { BrowserRouter } from "react-router-dom";
import Router from "./app/router";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./app/store";

import useApplyTheme from "./app/providers/useApplyTheme";

function AppWrapper() {
  // applique le thème dès le démarrage
  useApplyTheme();

  return <Router />;
}

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppWrapper />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
